:host {
   display: inline-flex !important;
}

input {
   position: absolute;
   clip: rect(0, 0, 0, 0);
   pointer-events: none;
}

.segmented-control-button {
   margin: 0;
   background-color: var(--tti-segmented-control-button-default-bg) !important;
   border-width: 1px;
   border-style: solid;
   border-color: var(--tti-segmented-control-button-default-border) !important;
   border-radius: 0;
   color: var(--tti-segmented-control-button-default-text) !important;
   margin-left: -1px;
   position: relative;
}

.first-button {
   border-left-style: solid !important;
   border-radius: 0.25rem 0 0 0.25rem;
   margin-left: 0;
}

.last-button {
   border-radius: 0 0.25rem 0.25rem 0;
}

.segmented-control-button:hover,
.segmented-control-button:focus-within {
   background-color: var(--tti-segmented-control-button-hover-bg) !important;
   border-color: var(--tti-segmented-control-button-hover-border) !important;
   color: var(--tti-segmented-control-button-hover-text) !important;
   font-weight: bold !important;
   z-index: 1;
}

input:checked + .segmented-control-button,
input:checked + .segmented-control-button:hover {
   background-color: var(--tti-segmented-control-button-active-bg) !important;
   border-color: var(--tti-segmented-control-button-active-border) !important;
   color: var(--tti-segmented-control-button-active-text) !important;
   font-weight: bold !important;
   z-index: 2;
}

input:checked:focus-visible + .segmented-control-button {
   box-shadow: none !important;
   outline: 2px solid var(--tti-segmented-control-button-focus-outline) !important;
   outline-offset: 2px;
}

.evenly-spread {
   flex-grow: 1;
}
.evenly-spread:has(:not(.icon:only-child)) {
   padding-left: 2rem;
   padding-right: 2rem;
}
.evenly-spread atlantis-icon:has(+ .label) {
   margin-left: -1.125rem;
}
